import { render, staticRenderFns } from "./PopularPages.vue?vue&type=template&id=4b3095e0"
import script from "./PopularPages.vue?vue&type=script&lang=js"
export * from "./PopularPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports